import { createFileRoute } from '@tanstack/solid-router';

import Header from '~/components/layout/Header';

export const Route = createFileRoute('/maintenance')({
    component: MaintenancePage
});

function MaintenancePage() {
    return (
        <div class="min-h-screen bg-white flex flex-col">
            <Header />

            <div class="flex-1 flex flex-col items-center justify-center p-6 text-center max-w-md mx-auto">
                <div class="w-20 h-20 mx-auto mb-6 bg-brand-yellow/20 rounded-full flex items-center justify-center">
                    <svg
                        class="w-10 h-10 text-brand-yellow"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24">
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
                        />
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                    </svg>
                </div>

                <h1 class="text-3xl font-heading font-bold text-brand-black">
                    We'll be back soon
                </h1>
                <p class="mt-4 text-gray-500 leading-relaxed">
                    We're performing scheduled maintenance to improve your
                    experience. Please check back in a little while.
                </p>
                <p class="mt-6 text-sm text-gray-400">
                    If you need immediate assistance, please contact us at{' '}
                    <a
                        href="mailto:sales@getsolar.ai"
                        class="text-brand-blue hover:underline">
                        sales@getsolar.ai
                    </a>
                </p>
            </div>
        </div>
    );
}
